import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
// @ts-ignore
import ImageResize from 'quill-image-resize-module-react';

Quill.register('modules/imageResize', ImageResize);

interface Props {
  onChange: (text: string) => void;
  value: string;
}

const RichText = (props: Props) => {
  const { onChange, value } = props;

  return (
    <ReactQuill
      modules={{
        toolbar: [
          ['bold', 'italic', 'underline'], // toggled buttons
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['image']
        ],
        imageResize: {
          parchment: Quill.import('parchment'),
          modules: ['Resize', 'DisplaySize']
        }
      }}
      style={{ height: '100%' }}
      theme="snow"
      value={value}
      onChange={onChange}
    />
  );
};

export default RichText;
